// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallChangeMemberPermissionPopup__wrapper-eb325d {
  margin: 0 24px 24px 24px;
}

.CallChangeMemberPermissionPopup__title-afe986 {
  font: var(--font-body-1);
  color: var(--base-110);
  margin: 24px 0 0 24px;
  letter-spacing: var(--font-spacing-body-1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallChangeMemberPermissionPopup/CallChangeMemberPermissionPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,0CAAA;AACF","sourcesContent":[".wrapper {\n  margin: 0 24px 24px 24px;\n}\n\n.title {\n  font: var(--font-body-1);\n  color: var(--base-110);\n  margin: 24px 0 0 24px;\n  letter-spacing: var(--font-spacing-body-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CallChangeMemberPermissionPopup__wrapper-eb325d`,
	"title": `CallChangeMemberPermissionPopup__title-afe986`
};
module.exports = ___CSS_LOADER_EXPORT___;
